import styles from './FooterLinkSet.scss';

import cx from 'classnames';
import React, { FC, HTMLAttributes } from 'react';

import { LinkSet } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentLinkV2 } from 'src/components/ContentLinkV2/ContentLinkV2';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';

export interface FooterLinkSetProps extends HTMLAttributes<HTMLElement> {
  entry: FlatEntry<LinkSet>;
  linkClassName?: string;
  listClassName?: string;
  listItemClassName?: string;
  titleClassName?: string;
}

export const FooterLinkSet: FC<FooterLinkSetProps> = ({
  entry,
  linkClassName,
  listClassName,
  listItemClassName,
  titleClassName,
  ...props
}) => {
  const { title, items = [] } = entry;
  return (
    <nav aria-label={title} {...props}>
      <TextV2 className={titleClassName} value={title} entry={{ ...entry, field: 'title' }} />
      <ul className={listClassName}>
        {items.map(linkItem => (
          <li key={linkItem.id} className={listItemClassName}>
            <ContentLinkV2 className={cx(styles.link, linkClassName)} entry={linkItem} />
          </li>
        ))}
      </ul>
    </nav>
  );
};

FooterLinkSet.displayName = 'FooterLinkSet';
